"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserNavOverridesSchema = exports.UserDetailsSchema = exports.FeatureSchema = exports.EntitySchema = exports.UserSchema = exports.PatchMultipleConfigsRequestBodySchema = exports.UpsertMultipleConfigsRequestBodySchema = exports.UserConfigSchema = exports.UserConfigDefinitionSchema = void 0;
const zod_1 = require("zod");
exports.UserConfigDefinitionSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.any());
exports.UserConfigSchema = zod_1.z.object({
    config_id: zod_1.z.string(),
    identity_provider_user_id: zod_1.z.string(),
    type: zod_1.z.string(),
    definition: exports.UserConfigDefinitionSchema,
    created_at: zod_1.z.string(),
    updated_at: zod_1.z.string(),
    deleted_at: zod_1.z.string().nullable(),
});
exports.UpsertMultipleConfigsRequestBodySchema = zod_1.z
    .array(exports.UserConfigSchema.pick({
    config_id: true,
    type: true,
    definition: true,
}).strict())
    .nonempty();
exports.PatchMultipleConfigsRequestBodySchema = zod_1.z
    .array(exports.UserConfigSchema.pick({
    config_id: true,
    definition: true,
}).strict())
    .nonempty();
exports.UserSchema = zod_1.z.object({
    identity_provider_user_id: zod_1.z.string(),
    user_id: zod_1.z.string(),
    email: zod_1.z.string(),
    name: zod_1.z.string(),
    has_tool_access: zod_1.z.boolean(),
});
exports.EntitySchema = zod_1.z.object({
    entity_id: zod_1.z.string(),
    name: zod_1.z.string(),
    suspended: zod_1.z.boolean(),
    trial: zod_1.z.boolean(),
    end_date: zod_1.z.string().nullable(),
    start_date: zod_1.z.string().nullable(),
    team_id: zod_1.z.number().nullable(),
});
exports.FeatureSchema = zod_1.z.object({
    licensed_game_count: zod_1.z.number(),
    video: zod_1.z.boolean(),
});
exports.UserDetailsSchema = zod_1.z.object({
    user: exports.UserSchema,
    entity: exports.EntitySchema,
    features: exports.FeatureSchema,
});
exports.UserNavOverridesSchema = zod_1.z
    .object({
    player: zod_1.z.boolean(),
    player_scout: zod_1.z.boolean(),
})
    .strict();
//# sourceMappingURL=user.js.map